import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useEffect } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireOperationalEvent } from '../analytics';
import { useTeamsPermissionsStore } from './teams-permission-store';
export var useTeamsPermissionsService = function useTeamsPermissionsService(scope) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      enabled: false,
      attributes: {}
    },
    enabled = _ref.enabled,
    attributes = _ref.attributes;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;

  // backwards compatibility allow orgId to be passed as a string
  var _ref2 = typeof scope === 'string' || !scope ? {
      orgId: scope,
      cloudId: undefined
    } : scope,
    orgId = _ref2.orgId,
    cloudId = _ref2.cloudId;
  var _useTeamsPermissionsS = useTeamsPermissionsStore(),
    _useTeamsPermissionsS2 = _slicedToArray(_useTeamsPermissionsS, 2),
    state = _useTeamsPermissionsS2[0],
    getPermissions = _useTeamsPermissionsS2[1].getPermissions;
  var fetchData = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
          }, {
            onFetch: function onFetch() {
              return fireOperationalEvent(createAnalyticsEvent, {
                action: 'fetched',
                actionSubject: 'use-team-permissions',
                attributes: {
                  userId: attributes === null || attributes === void 0 ? void 0 : attributes.userId,
                  orgId: orgId,
                  cloudId: cloudId
                }
              });
            }
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [orgId, cloudId, enabled, getPermissions, createAnalyticsEvent, attributes === null || attributes === void 0 ? void 0 : attributes.userId]);
  useEffect(function () {
    fetchData();
  }, [fetchData]);
  return _objectSpread({
    loading: state.isLoading,
    data: state.permissionsResponse,
    error: state.error
  }, state);
};